import '../scss/navigation.scss';

const Navigation = () => {
  return (
    <div className="user-account-dashboard-inner-wrapper">
      <div className="user-account-dashboard-navbar">
        <div className="navbar-btn">
          <i className="fas fa-tachometer-alt"></i>
          <div className="btn-label">dashboard</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-user-circle"></i>
          <div className="btn-label">profile</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-utensils"></i>
          <div className="btn-label">nutrition</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-heartbeat"></i>
          <div className="btn-label">programs</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-newspaper"></i>
          <div className="btn-label">newsfeed</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-comments"></i>
          <div className="btn-label">messages</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-users"></i>
          <div className="btn-label">groups</div>
        </div>
        <div className="navbar-btn">
          <i className="fas fa-download"></i>
          <div className="btn-label">downloads</div>
        </div>
      </div>
    </div>
  )
}

export default Navigation;